module.exports = __webpack_public_path__ + "static/media/Collections-Corporate-mobile.1a4df23f.jpg";